import React, { useState } from 'react';
import styles from './ValidateChoiceButton.module.scss';

type ValidateChoiceButtonProps = {
    title: string;
    onValidate: () => void;
    selected?: boolean;
    fullWidth?: boolean;
    inactive?: boolean;
    tooltipText?: string;
    enableTooltip?: boolean;
}

const ValidateChoiceButton: React.FC<ValidateChoiceButtonProps> = ({
    title,
    onValidate,
    selected,
    fullWidth,
    inactive = false,
    enableTooltip = true,
    tooltipText = "Bientôt disponible"
}) => {
    const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

    const handleClick = () => {
        if (inactive) return;
        onValidate();
    };
    
    const handleShowTooltip = () => {
        if (inactive && enableTooltip) {
            setIsTooltipVisible(true);
        }
    };
    
    const handleHideTooltip = () => {
        setIsTooltipVisible(false);
    };

    return (
        <div className={styles.buttonWrapper} style={{ width: fullWidth ? '100%' : '230px' }}>
            <button
                type="button" 
                className={`
                    ${styles.buttonContainer} 
                    ${selected ? styles.selected : ''}
                    ${inactive ? styles.inactive : ''}
                `} 
                style={{ width: fullWidth ? '100%' : '230px' }}
                onMouseEnter={handleShowTooltip}
                onMouseLeave={handleHideTooltip}
                onFocus={handleShowTooltip}
                onBlur={handleHideTooltip}
                onClick={handleClick}
            >
                <p className={styles.buttonLabel}>{title}</p>
            </button>
            {enableTooltip && isTooltipVisible && (
                <div className={styles.tooltip}>
                    {tooltipText}
                </div>
            )}
        </div>
    );
}

export default ValidateChoiceButton;
